import { render, staticRenderFns } from "./TenantForm.vue?vue&type=template&id=be634728&"
import script from "./TenantForm.vue?vue&type=script&lang=js&"
export * from "./TenantForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be634728')) {
      api.createRecord('be634728', component.options)
    } else {
      api.reload('be634728', component.options)
    }
    module.hot.accept("./TenantForm.vue?vue&type=template&id=be634728&", function () {
      api.rerender('be634728', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/TenantForm.vue"
export default component.exports